export default {
    namespaced: true,
    state: {
        header: {}
    },
    getters: {},
    mutations: {
        saveHeader(state, payload){
            state.header = payload
        }
    }
}